import React, { useEffect, useState } from "react";
import { X, Save, Edit2, Trash2, Tag } from "lucide-react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);
const API = "https://apiftpsplit.ftpeople.pl";
const hdrs = { "Content-Type": "application/json", Authorization: secretKey };

const AddStatus = (props) => {
  const isEdit = props.mode === "edit";
  const [loading, setLoading] = useState(true);
  const [leads, setLeads] = useState([]);
  const [editing, setEditing] = useState(!isEdit);

  const [name, setName] = useState(isEdit ? props.statusEdit.name : "");
  const [color, setColor] = useState(
    isEdit ? props.statusEdit.color : "#ff8c00"
  );
  const [poz, setPoz] = useState(isEdit ? props.statusEdit.poz : "");

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/getLeadsAssDataStatus`, {
          method: "POST",
          headers: hdrs,
          body: "{}",
        });
        setLeads(await res.json());
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    })();
  }, []);

  const validate = () => {
    if (!name.trim() || !color) {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      });
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    if (!validate()) return;
    const endpoint = isEdit ? "editStatus" : "addStatus";
    const body = isEdit
      ? { id: props.statusEdit.id, name, color, poz }
      : { name, color, poz };
    try {
      await fetch(`${API}/${endpoint}`, {
        method: "POST",
        headers: hdrs,
        body: JSON.stringify(body),
      });
      MySwal.fire({
        icon: "success",
        title: "Status",
        text: isEdit ? "zmieniony" : "dodany",
      });
      props.close();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = () => {
    const count = leads.filter(
      (l) => l.status === props.statusEdit.name
    ).length;
    if (count > 0) {
      MySwal.fire({
        icon: "error",
        title: "Nie można usunąć",
        text: `Przypisano ${count} leadów do tego statusu`,
      });
      return;
    }
    fetch(`${API}/deleteStatus`, {
      method: "POST",
      headers: hdrs,
      body: JSON.stringify({ id: props.statusEdit.id }),
    })
      .then(() => {
        MySwal.fire({ icon: "success", title: "Status", text: "usunięty" });
        props.close();
      })
      .catch(() => {});
  };

  const cancelEdit = () => {
    setEditing(false);
    setName(props.statusEdit.name);
    setColor(props.statusEdit.color);
    setPoz(props.statusEdit.poz);
  };

  if (loading) return <Loading />;

  return (
    <div
      className="sn-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) props.close();
      }}
    >
      <div className="sn-modal" style={{ maxWidth: 520 }}>
        {/* Header */}
        <div className="sn-header">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Tag size={18} />
            <h2 className="sn-title">
              {editing ? (isEdit ? "Edytuj status" : "Dodaj status") : "Status"}
            </h2>
          </div>
          <button className="ld-close" onClick={props.close}>
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="sn-body">
          {/* Preview */}
          {color && (
            <div className="as-preview">
              <span
                className="as-preview-dot"
                style={{ background: color }}
              ></span>
              <span className="as-preview-name">{name || "Nazwa statusu"}</span>
              {poz && <span className="as-preview-poz">poz. {poz}</span>}
            </div>
          )}

          <div className="scc-form-grid">
            <div className="rp-field">
              <label className="db-field-label">
                Nazwa <span className="scc-req">*</span>
              </label>
              <input
                type="text"
                className="db-input"
                disabled={!editing}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="rp-field">
              <label className="db-field-label">Pozycja sortowania</label>
              <input
                type="number"
                className="db-input"
                disabled={!editing}
                value={poz}
                onChange={(e) => setPoz(e.target.value)}
                min={0}
              />
            </div>
            <div className="rp-field" style={{ gridColumn: "1 / -1" }}>
              <label className="db-field-label">
                Kolor <span className="scc-req">*</span>
              </label>
              <div className="as-color-row">
                <input
                  type="color"
                  className="as-color-input"
                  disabled={!editing}
                  value={color}
                  onChange={(e) => setColor(e.target.value)}
                />
                <span className="adm-color-hex">{color}</span>
              </div>
            </div>
          </div>

          <div className="scc-form-footer">
            {editing && (
              <button className="lq-btn lq-btn--success" onClick={handleSave}>
                <Save size={14} /> {isEdit ? "Zapisz" : "Dodaj"}
              </button>
            )}

            {isEdit && !editing && (
              <button
                className="lq-btn lq-btn--primary"
                onClick={() => setEditing(true)}
              >
                <Edit2 size={14} /> Edytuj
              </button>
            )}

            {isEdit && editing && (
              <button className="lq-btn lq-btn--muted" onClick={cancelEdit}>
                Anuluj edycję
              </button>
            )}

            {isEdit && (
              <button className="lq-btn lq-btn--danger" onClick={handleDelete}>
                <Trash2 size={14} /> Usuń
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddStatus;
